export default {
    QUANTIDADE: 20,
}